<style lang="postcss">
  .flexed {
    flex: 1 0 auto;
    transition: 500ms ease-in;
  }
  .disconnected-gradient-border, .connected-gradient-border {
    --borderWidth: 3px;
    position: relative;
  }

  .disconnected-gradient-border:hover {
    @apply animate-tilt;
  }
  .disconnected-gradient-border:after, .connected-gradient-border:after {
    @apply blur;
    content: '';
    position: absolute;
    top: calc(-1 * var(--borderWidth));
    left: calc(-1 * var(--borderWidth));
    height: calc(100% + var(--borderWidth) * 2);
    width: calc(100% + var(--borderWidth) * 2);
    border-radius: calc(4 * var(--borderWidth));
    z-index: -1;
    animation: animatedgradient 3s ease alternate infinite;
    background-size: 300% 300%;
  }

  .disconnected-gradient-border:after {
    background-image: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #d51be2, rgb(180, 78, 132));
  }
  .connected-gradient-border:after {
    @apply bg-gradient-to-r from-yellow-200 via-green-200 to-green-500;
  }
  @keyframes animatedgradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
</style>
<!-- svelte-ignore a11y-mouse-events-have-key-events -->
<button id='providerButton' class="rounded-lg w-44 py-2 px-2 font-medium text-white {borderClass} {connectedStatusClass} {connectedHoverClass}" on:click={connectWallet} on:mouseenter|stopPropagation={onHoverConnectButton} on:mouseleave|stopPropagation={onMouseOutConnectButton}>
  <!-- svelte-ignore a11y-mouse-events-have-key-events -->  
  <div class="flex flex-row flexed">
    {#if (!$connected && (wrongNetwork == true) || noProvider)}
      <div class="pr-1 text-lg">
        <svg xmlns="http://www.w3.org/2000/svg" class='svg' width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline class='polyline' points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>
      </div>  
    {/if}
    <div class="text-center w-full text-lg">{noProvider || "  "+connectText+"  "}</div>
    {#if ($connected && $walletData['address'])}
      <Jazzicon localAddress='' diameter='30' />
    {/if}
  </div>
</button>

<script>
  import { ethers } from "ethers";
  //import { createEventDispatcher } from 'svelte';
  import {location, push, pop, replace} from 'svelte-spa-router'
  import { connected } from './../stores.js';
  import { walletData } from './../stores.js';

  import Jazzicon from './jazzicon.svelte';

  // <-- NavBar -->

  // <--- Svelte --->

  //const dispatch = createEventDispatcher()

  var connectedHoverClass;
  var wrongNetwork = false;
  var noProvider = false;
  var network;

  $: ($connected && actualizeAccount());

  $: connectText          = ($connected && $walletData['address'] ? $walletData['address'].replaceAll(/(......).{1,}(....)/g, "$1...$2") : (providerError) ? 'Bad Network' : 'Enter app');
  $: connectedStatusClass = ($connected) ? 'bg-green-600' : 'bg-primary';
  $: borderClass          = ($connected) ? 'connected-gradient-border' : 'disconnected-gradient-border';
  $: providerError        = (wrongNetwork == true) || noProvider;

  // <--- EtherJS --->

  function actualizeAccount() {
    (async () => {
      if (window.ethereum == null) {
        console.log('no provider');
        noProvider = 'No Web3';
      }
      else {
        var provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        var accounts = await provider.listAccounts();
        const signer = provider.getSigner();
        //setAddress(await signer.getAddress());
        //dispatch('webWalletConnection', address);

        // <-- Update Client Variable -->
        window.signer = signer;

        if(accounts.length > 0) {
          network = await provider.getNetwork()
          if (Number(network.chainId) == $walletData['networkId']) {
            setAddress(accounts[0]);
            set_connect();
          }
          else {
            if (network.chainId) {
              handleChainChanged(Number(network.chainId));
              wrongNetwork = true;
            }
          }

          provider.on('network', (network) => {
            handleChainChanged(network.chainId);
          });

          window.ethereum.on('accountsChanged', handleAccountsChanged);
        }
      }

    })();
  }

  function connectWallet() {
    if ($connected == true) {
      set_disconnect();
    }
    else {
      (async () => {
        console.log('test3', window.ethereum);
        const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        await provider.send("eth_requestAccounts", []);
        const signer = provider.getSigner();
        //setAddress(await signer.getAddress());
        //dispatch('webWalletConnection', address);

        // <-- Update Client Variable -->
        window.signer = signer;

        actualizeAccount();
      })();
    }

  }

  function handleAccountsChanged(accounts) {
    setAddress(accounts[0]);
    if (accounts.length == 0) {
      set_disconnect();
    }
  }

  function setAddress(_address) {
    walletData.update((currentWalletData) => {
      currentWalletData['address'] = _address;

      return currentWalletData;
    });
  }

  function handleChainChanged(_chainId) {
    if(Number(_chainId) != $walletData['networkId']) {
      wrongNetwork = true;
      set_disconnect();

      console.log('oyyyy');
        (async () => {
          try {
            await window.ethereum.request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId: '0x' + $walletData['networkIdHex'] }], // chainId must be in hexadecimal numbers
            });
          }
          catch {
            await ethereum.request({ method: 'wallet_addEthereumChain',
            params:[
                {
                  chainId: "0xe9ac0ce",
                  chainName: "Neon Testnet",
                  nativeCurrency: {
                    name: "NEON",
                    symbol: "NEON",
                    decimals: 18 //In number form
                  },
                  rpcUrls: ["https://proxy.devnet.neonlabs.org/solana"],
                  blockExplorerUrls: ["https://neonscan.org/"]
                }
            ]});
          }
        })();
    }
    else {
      window.location.reload();
    }
  }

  function set_connect() {
    if ($location == '/' || $location == '/Index') {
      push('/Index');
    }
    connected.update((currentConnected) => {
      return currentConnected = true;
    });
  }

  function set_disconnect() {
    push('/Index');

    connected.update((currentConnected) => {
      return currentConnected = false;
    });
  }

  function onHoverConnectButton(event) {
    if ($connected) {
      connectText = 'Disconnect';
      connectedHoverClass = 'hover:bg-pink-500';
    }
    else if (providerError) {
    }
    else {
      connectText = 'Enter app';
    }
  }


  function onMouseOutConnectButton(event) {
    if ($connected && $walletData['address']) {
      connectText = $walletData['address'].replaceAll(/(......).{1,}(....)/g, "$1...$2")
    }
    else if (providerError) {
    }
    else {
      connectText = 'Enter app'
    }
  }
</script>
